/**
 * @file 认证详情
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import Viewmod from '../attestStep/viewmod';
import {Form, FormItem, Button, Checkbox, Spin, Toast, Upload, Modal, Tips} from '@baidu/spui';
import './index.less';
import {fetchGetDetail, fetchSendCode, fetchAuthEdit, fetchDelete} from '../../actions/attestAction';
import {location} from '../attestStep/location';
import demo from '../../asset/img/单位号码证明函模板.docx';

const cascaderOptionData = [];

for (let attr in location[0]) {
    let children = [];
    for (let attr2 in location[`0,${attr}`]) {
        children.push({
            value: `${location[0][attr]},${location[`0,${attr}`][attr2]}`,
            name: location[`0,${attr}`][attr2]
        });
    }

    cascaderOptionData.push({
        value: location[0][attr],
        name: location[0][attr],
        children: children
    });
}

export class InfoAttest extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            type: false,
            spinOff: false,
            codeOff: false,
            codeOff1: false,
            logoId: false,
            checkboxValue1: false,
            checkboxValue2: false,
            Iscommit: false,
            certOther2Error: '',
            attestType: '2',
            formData: {},
            pageObj: {},
            modTop: 290,
            codeTime: 60,
            telTime: 60,
            checkboxValue: false,
        };
    }

    componentDidMount() {
        this.getDetailFn();

        this.scrollFn();
        window.addEventListener('scroll', this.scrollFn);
    }

    getDetailFn = () => {
        let id = this.props.match.params.id;
        let create_time = this.props.match.params.type;
        if (!id) {
            this.props.history.push('/');
        }
        this.props.fetchGetDetail({id: parseInt(id, 10), create_time}).then(data => {
            if (data.code === 200) {
                let obj = data.data.list;
                let json = {
                    display: obj.display,
                    phone: obj.phone,
                    tel: obj.tel,
                };
                this.setState({
                    pageObj: obj,
                    logoId: obj.company_logo_id,
                    checkboxValue1: obj.is_show === 1,
                    certOther2Id: obj.cert_other_2,
                    attestType: obj.type.toString(),
                    formData: json
                });
            } else {
                Toast.display({
                    type: 'error',
                    info: data.message,
                    delay: 3500
                });
            }
        });
    };
    checked = (n, value) => {
        const {
            tel, // 手机
            tel_code, // 手机验证码
            display, // 展示名称
        } = this.state.formData;
        const {phone} = this.state.pageObj;
        let checkboxValue2 = this.state.checkboxValue2;
        const {certOther2Id} = this.state;
        let checkp = {
            phone,
            certOther2Id, tel, tel_code, display, checkboxValue2
        };
        checkp[n] = value;
        for (let prop in checkp) {
            if (!checkp[prop]) {
                this.setState({
                    Iscommit: false
                });
                return;
            }
        }
        this.setState({
            Iscommit: true
        });
    };

    formItemGetValue = ({name, value}) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
        this.checked(name, value);
    };

    sendCodeFn = () => {
        let formData = this.state.formData;
        let tcode = 'telTime';
        let offt = 'codeOff1';

        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.fetchSendCode({
                type: 2,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                verity: formData.tel
            }).then(data => {
                if (data.code === 200) {
                    let timer = setInterval(() => {
                        let codeTime = this.state[tcode];
                        if (codeTime > 1) {
                            this.setState({
                                [tcode]: codeTime - 1
                            });
                        } else {
                            clearInterval(timer);
                            this.setState({
                                [tcode]: 60,
                                [offt]: false
                            });
                        }
                    }, 1000);
                } else {
                    this.setState({
                        [tcode]: 60,
                        [offt]: false
                    });
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }

            });
        };
    };

    scrollFn = () => {
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop < 250) {
            this.setState({
                modTop: 280,
                po: 'absolute'
            });
        } else {
            this.setState({
                modTop: 110,
                po: 'fixed'
            });
        }
    };

    submit = vlidate => {
        let id = this.props.match.params.id;
        let {
            formData,
            pageObj, certOther2Id
        } = this.state;
        let {
            tel, tel_code,
            display
        } = formData;
        let off = true;

        if (!certOther2Id) {
            this.setState({
                certOther2Error: '请上传单位证明函'
            });
            off = false;
        } else {
            this.setState({
                certOther2Error: false
            });
        }

        if (vlidate && off) {
            window.BCat_2055 && window.BCat_2055.miao();
            window['__abbaidu_2055_cb'] = responseData => {
                let localData = JSON.parse(responseData);
                let json = {
                    step: 1, // 步骤
                    type: this.state.attestType, // 认证类型
                    display: display, // 展示名称
                    phone: pageObj.phone, // 电话
                    data: localData.data,
                    'key_id': localData['key_id'],
                    sign: localData.sign,
                    id: parseInt(id, 10),
                    tel: tel,
                    'tel_code': tel_code,
                    'cert_other_2': [certOther2Id],
                    'is_read': 1
                };
                this.props.fetchAuthEdit(json).then(data => {
                    window['__abbaidu_2055_cb'] = null;
                    if (data.code === 200) {
                        this.setState({promptOff: false}, () => {
                            this.props.history.goBack();
                        });
                    } else {
                        Toast.display({
                            type: 'error',
                            info: data.message,
                            delay: 3500
                        });
                    }
                });
            };
        }
    };

    render() {
        let {id, type} = this.props.match.params;
        let {
            formData, modTop, pageObj, spinOff, codeOff1, telTime,
            checkboxValue2, certOther2Id,
            magnifyOff, magnifySrc, certOther2Error, Iscommit
        } = this.state;
        let reg1 = /^1[3456789]\d{9}$/;

        let phoneData = [];

        if (pageObj.phone) {
            phoneData = pageObj.phone.split(',');
        }

        let imgType = '';
        let title = '';
        let text = '';
        let urlStr = '/api/v1/image/get?product_id=haoma&img_id=';

        const titleClass = classnames({
            'info-mod': true,
            'success': pageObj.person_status === 1,
            'error': pageObj.person_status === 2,
            'ing': pageObj.person_status === 0
        });

        switch (pageObj.person_status) {
            case 1:
                imgType = 'icon_success';
                title = '审核通过';
                // color = '#40C87F';
                text = '恭喜您，提交的资料和号码已完成审核，您可以通过百度搜索相关数据查看';
                break;

            case 2:
                imgType = 'icon_error';
                title = '审核未通过';
                // color = '#FF5F67';
                text = pageObj.person_reason;
                break;

            case 0:
                imgType = 'icon_toast';
                title = '审核中';
                // color = '#FFF';
                text = <div>
                    <div>您当前提交的资质和号码，已经到审核阶段，工作人员正在快马加鞭的进行审核</div>
                    <div>我们会在7个工作日内完成审核，请您耐心等待</div>
                </div>;
                break;
        }


        const btnProps = {
            label: '修改信息',
            value: 'HAHAHA',
            disabled: pageObj.person_status === 0,
            styleType: 'modal',
            onClick: () => {
                this.props.history.push(`/info_attest/${id}/edit`);
            }
        };
        return (
            <div className={'infoAttest attest'}>
                {
                    !this.isEmptyobj(pageObj)
                        ? <div>
                            <div className={titleClass} style={{'height': 'auto'}}>
                                <div className={'top'}/>
                                <div className={'con'}>
                                    <div className={'left'}>
                                        <div className={'title'}>
                                            <img src={require(`../../asset/img/infoAttest/${imgType}.png`)} alt=""/>
                                            <div>{title}</div>
                                            {
                                                pageObj.source === 'history'
                                                    // title
                                                    ? <Tips title="该认证信息已在2021年3月底开启产品全面升级调整，建议您重新认证！"
                                                        placement={'right'}>
                                                        <img className="uptip"
                                                            src={require('../../asset/img/upgrade/error.svg')} alt=""/>
                                                    </Tips>
                                                    : null
                                            }
                                        </div>
                                        <div className={'text'}>
                                            {text}
                                        </div>
                                    </div>
                                    <div className={'right'}>
                                        提交时间：{pageObj.create_time}<br/>
                                        更新时间：{pageObj.update_time}<br/>
                                        到期时间：{pageObj.expired_time || '-'}
                                    </div>
                                </div>
                            </div>

                            {type === 'edit'
                                ? <div className={'info-from'}>
                                    <Form submit={this.submit} ref={el => (this.myFrom = el)} className={'width-960'}>
                                        <div className={'spui2-input-root margin-bottom-24'}>
                                            <div className={'from-mod-left spui2-form-label'}>
                                                <i className={'star'}>*</i><span>认证ID</span>
                                            </div>
                                            <div style={{display: 'inline-block', lineHeight: '40px'}}>
                                                {pageObj.id}
                                            </div>
                                        </div>
                                        <div className={'spui2-input-root margin-bottom-24'}>
                                            <div className={'from-mod-left spui2-form-label'}>
                                                <i className={'star'}>*</i><span>认证类型</span>
                                            </div>
                                            <div style={{display: 'inline-block', lineHeight: '40px'}}>
                                                政府/非盈利组织认证
                                            </div>
                                        </div>

                                        <FormItem
                                            type="input"
                                            value={formData.display}
                                            spellCheck={false}
                                            name={'display'}
                                            label={<span><i className={'star'}>*</i>展示名称</span>}
                                            placeHolder={'请输入展示名称'}
                                            getValue={this.formItemGetValue}
                                        />
                                        <div className={'spui2-input-root margin-bottom-24'}>
                                            <div className={'from-mod-left spui2-form-label'}>
                                                <i className={'star'}>*</i><span>认证号码</span>
                                            </div>
                                            <div style={{display: 'inline-block', lineHeight: '40px'}}>
                                                {pageObj.phone}
                                            </div>
                                        </div>
                                        <div className={'from-mod mt20 pb24'} style={{height: '200px'}}>
                                            <div className={'from-mod-left'}>
                                                <i className={'star'}>*</i><span>单位证明函</span>
                                            </div>
                                            <div className={'from-mod-right pr'}>
                                                <Upload
                                                    fileId={'feui-certOther2Id'}
                                                    uploadType={'image-upload'}
                                                    noWarning={true}
                                                    name={'image'}
                                                    width={'96px'}
                                                    height={'96px'}
                                                    onHandleChange={data => {
                                                        let file = data.value;
                                                        if (file.type.substr(-3) !== 'png'
                                                            && data.value.type.substr(-4) !== 'jpeg') {
                                                            this.setState({
                                                                certOther2Error: '图片格式不正确'
                                                            });
                                                            return false;
                                                        }

                                                        if (file.size > (1024 * 1024 * 10)) { // 1M
                                                            Toast.display({
                                                                type: 'error',
                                                                info: '图片大小过大',
                                                                delay: 3500
                                                            });
                                                            return false;
                                                        }
                                                        this.setState({
                                                            certOther2Error: ''
                                                        });

                                                        file.formDatas.append('product_id', 'haoma');
                                                        file.formDatas.append('is_spot', 'NO');

                                                        let myInit = {
                                                            method: 'POST',
                                                            credentials: 'include',
                                                            body: file.formDatas
                                                        };

                                                        fetch('/api/v1/image', myInit)
                                                            .then(response => response.json())
                                                            .then(response => {
                                                                if (response.code === 200) {
                                                                    this.setState({
                                                                        certOther2Id: response.data.id
                                                                    });
                                                                    this.checked('certOther2Id', response.data.id);
                                                                } else {
                                                                    Toast.display({
                                                                        type: 'error',
                                                                        info: response.message,
                                                                        delay: 3500
                                                                    });
                                                                }
                                                            });
                                                    }}
                                                />
                                                {certOther2Id
                                                    ? <div
                                                        className={'load-mod'}
                                                        style={{
                                                            backgroundImage: `url(${urlStr + certOther2Id})`
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                magnifySrc: `${urlStr + certOther2Id}`,
                                                                magnifyOff: true
                                                            });
                                                        }}
                                                    >
                                                        <div
                                                            className={'close'}
                                                            onClick={e => {
                                                                this.setState({
                                                                    certOther2Id: false
                                                                });
                                                                this.checked('certOther2Id', false);
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                    </div>
                                                    : null
                                                }
                                                {
                                                    certOther2Error
                                                        ? <div className="spui2-form-warning">
                                                            <i className="spui2-input-error"/>
                                                            <span>{certOther2Error}</span>
                                                        </div>
                                                        : null
                                                }
                                                <div style={{marginTop: '10px'}}>
                                                    <a
                                                        className={'down'}
                                                        href={demo}
                                                        download={'单位号码证明函模板.docx'}>模板下载
                                                    </a>
                                                </div>
                                                <div
                                                    className={'icon-text'}
                                                    style={{width: '400px', position: 'relative', left: '0', top: '0'}}
                                                >
                                                    <div>
                                                        <span>上传说明：单位证明函用于证实该企业名称合法有效</span><br/>
                                                        <span>上传要求：证明函需要盖单位鲜章,济宁支持jpg或png格式，大小不超过10M</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={'form-mod2'}>
                                            <div>
                                                <FormItem
                                                    type="input"
                                                    value={formData.tel}
                                                    spellCheck={false}
                                                    name={'tel'}
                                                    horizontal={true}
                                                    label={<span><i className={'star'}>*</i>联系电话</span>}
                                                    placeHolder={'请输入正确的手机号码用来接收通知'}
                                                    rules={
                                                        [{
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        },
                                                        {
                                                            validate(value) {
                                                                return !reg1.test(value);
                                                            },
                                                            message: '手机格式不正确！'
                                                        }]
                                                    }
                                                    getValue={this.formItemGetValue}
                                                />

                                                <FormItem
                                                    type="input"
                                                    value={formData.tel_code}
                                                    spellCheck={false}
                                                    name={'tel_code'}
                                                    horizontal={true}
                                                    width={'120px'}
                                                    label={<span><i className={'star'}>*</i>手机验证码</span>}
                                                    placeHolder={'请输入验证码'}
                                                    tips={!codeOff1
                                                        ? <span
                                                            className={reg1.test(formData.tel) ? 'link' : 'disable'}
                                                            onClick={() => {
                                                                if (reg1.test(formData.tel)) {
                                                                    this.setState({
                                                                        codeOff1: true
                                                                    }, () => {
                                                                        this.sendCodeFn();
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            获取验证码
                                                        </span>
                                                        : <span className={'disable'}>
                                                            {telTime}s后重新发送
                                                        </span>
                                                    }
                                                    rules={
                                                        [{
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        }]
                                                    }
                                                    getValue={this.formItemGetValue}
                                                />
                                                <div className={'form-check'}>
                                                    <Checkbox
                                                        name="zzz2"
                                                        value="rrr2"
                                                        checked={checkboxValue2}
                                                        theme={'blue'}
                                                        getValue={e => {
                                                            this.setState({
                                                                checkboxValue2: e.checked
                                                            });
                                                            this.checked('checkboxValue2', e.checked);
                                                        }}
                                                    >
                                                        <span>已阅读</span>
                                                        <a
                                                            href="https://haoma.baidu.com/privacy/agreement.html"
                                                            className={'link line'}
                                                            rel="noopener noreferrer"
                                                            target={'_blank'}>
                                                            《企业号码认证服务协议》
                                                        </a>
                                                        <span>和</span>
                                                        <a
                                                            href="https://haoma.baidu.com/privacy/index.html"
                                                            className={'link line'}
                                                            rel="noopener noreferrer"
                                                            target={'_blank'}>
                                                            《百度号码认证服务隐私政策》
                                                        </a>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={'form-btn'}>
                                            <div>
                                                <FormItem
                                                    name={'f12'}
                                                    className={'spui2-m-r10'}
                                                    styleType={'ghost'}
                                                    label={'取消修改'}
                                                    type="button"
                                                    onClick={() => {
                                                        this.props.history.push(
                                                            `/info_attest/${id}/${pageObj.create_time}`
                                                        );
                                                    }}
                                                />
                                                {!Iscommit
                                                    ? <Tips
                                                        title="输入所有必填项后可提交"
                                                        placement={'bottom-left'}
                                                        className={'leftip'}
                                                        preventOverflowEnabled={false}>
                                                        <FormItem
                                                            name={'f11'}
                                                            styleType={'modal'}
                                                            label={'提交修改'}
                                                            disabled={!Iscommit}
                                                            submitFlag={true}
                                                            type="button"
                                                        />
                                                    </Tips>
                                                    : <FormItem
                                                        name={'f11'}
                                                        styleType={'modal'}
                                                        label={'提交修改'}
                                                        disabled={!Iscommit}
                                                        submitFlag={true}
                                                        type="button"
                                                    />
                                                }

                                            </div>

                                            {spinOff
                                                ? <div>
                                                    <Spin
                                                        type={'small'}
                                                        description={'正在检测当前数据是否正确，请稍等'}
                                                    />
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </Form>
                                </div>
                                : <div className={'info-from'}
                                    style={{display: 'flex', flexWrap: 'wrap'}}
                                >
                                    <div className={'mt20'}>
                                        <div className={'mod-label'}>
                                            <div className={'left'}>
                                                <i className={'star'}>*</i><span>认证ID</span>
                                            </div>
                                            <div className={'right'}>
                                                {pageObj.id}
                                            </div>
                                        </div>
                                        <div className={'mod-label'}>
                                            <div className={'left'}>
                                                <i className={'star'}>*</i><span>认证类型</span>
                                            </div>
                                            <div className={'right'}>
                                                政府/非盈利组织认证
                                            </div>
                                        </div>
                                        <div className={'mod-label'}>
                                            <div className={'left'}>
                                                <i className={'star'}>*</i><span>展示名称</span>
                                            </div>
                                            <div className={'right'}>
                                                {pageObj.display ? pageObj.display : '-'}
                                            </div>
                                        </div>

                                        <div className={'mod-label'}>
                                            <div className={'left'}>
                                                <i className={'star'}>*</i><span>认证号码</span>
                                            </div>
                                            <div className={'right'}>
                                                {pageObj.phone ? pageObj.phone : '-'}
                                            </div>
                                        </div>
                                        <div className={'mod-label'}>
                                            <div className={'mod-img mt24'}>
                                                {pageObj.cert_other_2
                                                    ? <div>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>单位证明函</span>
                                                        </div>
                                                        <div
                                                            className={'img'}
                                                            style={{
                                                                backgroundImage: `url(${
                                                                    urlStr + pageObj.cert_other_2
                                                                })`
                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    magnifySrc: `${urlStr
                                                                    + pageObj.cert_other_2}`,
                                                                    magnifyOff: true
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className={'mod-label'}>
                                            <div className={'left'}>
                                                <i className={'star'}>*</i><span>联系电话</span>
                                            </div>
                                            <div className={'right'}>
                                                {pageObj.tel ? pageObj.tel : '-'}
                                            </div>
                                        </div>
                                    </div>
                                    {/*<Viewmod phone={pageObj.phone} name={formData.name} modTop={modTop}/>*/}
                                </div>
                            }
                            {type === 'edit'
                                && (<Viewmod phone={pageObj.phone} name={formData.display} modTop={modTop}
                                    po={this.state.po}/>)
                            }

                        </div>
                        : null
                }
                {magnifyOff
                    ? <div
                        className={'magnify'}
                        onClick={() => {
                            this.setState({magnifyOff: false});
                        }}
                    >
                        <img
                            src={magnifySrc}
                            alt=""
                            onClick={e => {
                                e.stopPropagation();
                            }}
                        />
                    </div>
                    : null
                }
            </div>
        );
    }
}

InfoAttest.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    fetchAuthEdit: PropTypes.func,
    fetchGetDetail: PropTypes.func,
    fetchSendCode: PropTypes.func,
    fetchDelete: PropTypes.func,
};

function mapStateToProps(state) {
    return {userInfo: state.userInfo};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAuthEdit: obj => fetchAuthEdit(dispatch, obj),
        fetchGetDetail: obj => fetchGetDetail(dispatch, obj),
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        fetchDelete: obj => fetchDelete(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InfoAttest));
